/** Browser mic/speaker helpers when the PTT sidecar is offline. */

let primed = false;

export function primeBrowserAudio(): void {
  if (primed || typeof window === "undefined") return;
  const synth = window.speechSynthesis;
  if (synth) {
    synth.getVoices();
    const warmup = new SpeechSynthesisUtterance(" ");
    warmup.volume = 0;
    warmup.rate = 10;
    synth.speak(warmup);
  }
  try {
    const ctx = new AudioContext();
    void ctx.resume().then(() => ctx.close());
  } catch {
    // AudioContext may be unavailable in test envs.
  }
  primed = true;
}

export function browserSpeak(text: string): void {
  if (!text || !window.speechSynthesis) return;
  const synth = window.speechSynthesis;

  const speakNow = () => {
    synth.cancel();
    const utt = new SpeechSynthesisUtterance(text);
    utt.lang = "en-US";
    const enVoice = synth.getVoices().find((v) => v.lang.startsWith("en"));
    if (enVoice) utt.voice = enVoice;
    synth.speak(utt);
  };

  if (synth.getVoices().length > 0) {
    speakNow();
    return;
  }

  const onVoices = () => {
    synth.removeEventListener("voiceschanged", onVoices);
    speakNow();
  };
  synth.addEventListener("voiceschanged", onVoices);
  synth.getVoices();
}
